import { PageHeader } from "@/components/PageHeader";
import { Button } from "@/components/ui/Button";
import * as shared from "@/styles/shared";
import { MapPin, Plus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { AddressDialog } from "./addresses/AddressDialog";
import { AddressesProvider, useAddresses } from "./addresses/AddressesContext";
import { AddressList } from "./addresses/AddressList";
import { AssignProviderDialog } from "./addresses/AssignProviderDialog";
import { EditProviderDialog } from "./addresses/EditProviderDialog";
import { styles } from "./AddressesPage.styles";

const AddressesPage = () => (
  <AddressesProvider>
    <div className={shared.page}>
      <AddressesPageHeader />
      <AddressesContent />
      <AddressDialog />
      <AssignProviderDialog />
      <EditProviderDialog />
    </div>
  </AddressesProvider>
);

const AddressesPageHeader = () => {
  const { t } = useTranslation(["common", "addresses"]);
  const { openCreate } = useAddresses();

  return (
    <PageHeader
      icon={MapPin}
      title={t("addresses:pageTitle")}
      action={
        <Button variant="gradient" iconOnly={false} leftIcon={Plus} onClick={openCreate}>
          {t("addresses:addAddress")}
        </Button>
      }
    />
  );
};

const AddressesContent = () => {
  const { t } = useTranslation(["common", "addresses"]);
  const { loading, addresses, openCreate } = useAddresses();

  if (loading) {
    return (
      <div className={shared.formStack}>
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className={styles.loadingItem} />
        ))}
      </div>
    );
  }

  if (!addresses.length) {
    return (
      <div className={shared.emptyState}>
        <MapPin className={styles.emptyIcon} />
        <p className={styles.emptyText}>{t("addresses:noAddressesYet")}</p>
        <p className={styles.emptyHint}>{t("addresses:noAddressesHint")}</p>
        <button className={styles.emptyAction} onClick={openCreate}>
          <Plus className={shared.iconSm} />
          {t("addresses:addAddress")}
        </button>
      </div>
    );
  }

  return <AddressList />;
};

export default AddressesPage;
